export default __webpack_public_path__ + "static/makers-ff0c547d50b469e2bbf2db8b130f2419.png";